import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewMedia = (id) => {
  return useQuery({
    queryKey: ['viewMediaDetails', id],
    enabled: !!id, 
    queryFn: async ({ queryKey }) => {
      const mediaId = queryKey[1];   
      const res = await api.get(`/media/show/${mediaId}`);
      return res.data;
    },
  });
};